<div class="unknown-rate-container">
  <!-- Summary section for all customers -->
  <div class="summary-info">
    <!-- Total Tickets (First stage) -->
    <div class="summary-box funnel-stage position-relative">
      <div class="summary-value">{{ topTicketInfo !== null ? topTicketInfo['total_tickets_count'] : 0 }}</div>
      <div class="summary-label">Total ticket count</div>
    </div>

    <!-- Connector between first and second -->
    <div class="funnel-connector">
      <div class="connector-arrow"></div>
    </div>

    <!-- Unknown Tickets (Second stage) -->
    <div class="summary-box funnel-stage position-relative">
      <div class="summary-value">{{ topTicketInfo !== null ? topTicketInfo['total_unknown_count'] : 0 }}</div>
      <div class="summary-label">Unknown ticket count</div>
    </div>

    <!-- Connector between second and third -->
    <div class="funnel-connector">
      <div class="connector-arrow"></div>
    </div>

    <!-- Percentage Unknown (Final stage) -->
    <div class="summary-box funnel-stage position-relative">
      <div class="summary-value">{{ topTicketInfo !== null ? topTicketInfo['total_unknown_percentage'] : 0 }}%</div>
      <div class="summary-label">Percentage unknown</div>
    </div>
  </div>

  <!-- Chart section for top 5 customers -->
  <div class="section-title">Top 5 Contributors by Unknown Ticket Count</div>
  <kendo-chart>
    <kendo-chart-series>
      <kendo-chart-series-item
        type="bar"
        [data]="sortedUnknownRateData"
        field="customer_unknown_rate_percent"
        categoryField="customer"
      >
        <kendo-chart-series-item-labels
          position="outsideEnd"
          [visible]="true"
          format="{0}%"
        ></kendo-chart-series-item-labels>
      </kendo-chart-series-item>
    </kendo-chart-series>
    <kendo-chart-category-axis>
      <kendo-chart-category-axis-item [labels]="{ rotation: 0 }"></kendo-chart-category-axis-item>
    </kendo-chart-category-axis>
    <kendo-chart-value-axis>
      <kendo-chart-value-axis-item
        [min]="0"
        [max]="getMaxValueAxis()"
        [title]="{ text: 'Unknown Rate (%)' }"
      ></kendo-chart-value-axis-item>
    </kendo-chart-value-axis>
    <kendo-chart-tooltip>
      <ng-template
        kendoChartSeriesTooltipTemplate
        let-value="value"
        let-category="category"
      >
        <div class="custom-tooltip">
          <div class="tooltip-title">{{ category }}</div>
          <div class="tooltip-row">
            <span class="tooltip-label">Unknown Rate:</span>
            <span class="tooltip-value">{{ value }}%</span>
          </div>
          <div class="tooltip-row">
            <span class="tooltip-label">Total Tickets:</span>
            <span class="tooltip-value">{{ getTicketCount(category) }}</span>
          </div>
          <div class="tooltip-row">
            <span class="tooltip-label">Unknown Tickets:</span>
            <span class="tooltip-value">{{ getUnknownTicketCount(category) }}</span>
          </div>
        </div>
      </ng-template>
    </kendo-chart-tooltip>
  </kendo-chart>
</div>
